import point from "../point";
import line from "../line";
import config from "../../../store/sqftConfig";

const wideAngleReverted = function() {
  let points;
  if(config.measureUnit === "Metric" ) {
    points = [
      new point(181, -19.62, "lefttop"),
      new point(181, 78, "righttop"),
      new point(157.38, 78, "rightbottom", true),
      new point(157.38, 4, "leftbottom"),
      new point(0, 4, "leftbottom"),
      new point(0, -19.62, "leftbottom")
    ];
  } else {
    points = [
      new point(181, -22, "lefttop"),
      new point(181, 78, "righttop"),
      new point(155, 78, "rightbottom", true),
      new point(155, 4, "leftbottom"),
      new point(0, 4, "leftbottom"),
      new point(0, -22, "leftbottom")
    ];
  }

  let lines = [
    new line(points[0], points[1]),
    new line(points[1], points[2]),
    new line(points[2], points[3]),
    new line(points[3], points[4]),
    new line(points[4], points[5]),
    new line(points[5], points[0])
  ];

  return lines;
};

export default wideAngleReverted
